import axios from "../../axiosClient";

export const getGeneralConfigurationParameters = async (
  assetCode: string | null,
  signal: any,
) => {
  const res = await axios.get(
    `/slpapp/GeneralParameter/GetGeneralConfigurationParameters`,
    {
      params: { assetCode },
      signal,
    },
  );

  return res?.data;
};

export const SendCommandToGetAssetConfiguration = async (
  assetCode: string | null,
  signal: any,
) => {
  const res = await axios.post(
    `/slpapp/GetCommand/SendCommandToGetAssetConfiguration`,
    undefined,
    {
      params: { assetCode },
      signal,
    },
  );

  return res?.data;
};

export const getAssetGeneralConfigurationHistoryDetail = async (
  historyId: number,
  signal: any,
) => {
  const res = await axios.post(
    `/slpapp/SetCommand/getAssetGeneralConfigurationHistoryDetail`,
    undefined,
    {
      params: { historyId },
      signal,
    },
  );

  return res?.data;
};

export const getGeneralConfigurationParametersFromDevice = async (
  assetCode: string | null,
  signal: any,
) => {
  const res = await axios.get(
    `/slpapp/GeneralParameter/GetGeneralConfigurationParametersFromDevice`,
    {
      params: { assetCode },
      signal,
    },
  );

  return res?.data;
};

export type BaselineConfigurationItem = {
  configurationParameterId: number;
  value: string;
};

export const setBaselineConfigurations = async (
  assetCode: string | null,
  configurationItems: BaselineConfigurationItem[],
  signal?: any,
) => {
  const res = await axios.post(
    `/slpapp/GeneralParameter/SetBaselineConfigurations`,
    { assetCode, configurationItems },
    { signal },
  );

  return res?.data;
};

export const applyBaselineAsParameters = async (
  assetCode: string | null,
  configurationItems: BaselineConfigurationItem[],
) => {
  const res = await axios.post(`/slpapp/SetCommand/applyBaselineAsParameters`, {
    assetCode,
    configurationItems,
  });

  return res?.data;
};

export type AssetGeneralConfigurationPayload = {
  assetCode: string | null;
  operationModeId: string | null;
  failsafeDelay: number | null;
  rampUpTime: number | null;
  rampDownTime: number | null;
  dimLevel: number | null;
  brightLevel: number | null;
  timeDelay: number | null;
  detectionRangeId: number | null;
  photoLowerThreshold: number | null;
  photoUpperThreshold: number | null;
  photoSensing: boolean | null;
};

export const setAssetGeneralConfiguration = async (
  payload: AssetGeneralConfigurationPayload,
) => {
  console.log("setAssetGeneralConfiguration payload", payload);
  const res = await axios.post(
    `/slpapp/SetCommand/SetAssetGeneralConfiguration`,
    payload,
  );

  return res?.data;
};

export type AssetConfigurationHistoryItem = {
  id: number;
  title: string;
  parametersModified: number;
  sentOn: string;
  ackTime: string | null;
  status: string;
  initiatedBy: string | null;
  totalCount: number;
};

export type AssetConfigurationHistoryResponse = {
  status: number;
  message: string;
  numberOfRecords: number;
  data: AssetConfigurationHistoryItem[];
  error: string | null;
};

export type AssetConfigurationHistoryQuery = {
  assetCode: string;
  pageNumber: number;
  searchText?: string;
  // status?: string;
  startDate?: string;
  endDate?: string;
  sortBy?: string;
  sortDirection?: string;
  pageSize: number;
  ackstatus: string;
};

export const getAssetGeneralConfigurationHistory = async (
  query: AssetConfigurationHistoryQuery,
) => {
  const { assetCode, ackstatus, ...body } = query;

  const res = await axios.post(
    `/slpapp/SetCommand/getAssetGeneralConfigurationHistory`,
    body,
    { params: { assetCode, ackstatus } },
  );

  return res?.data;
};

export const getOperationModes = async (signal?: any) => {
  const res = await axios.get(`/slpapp/OperationMode/OperationMode`, {
    signal,
  });

  return res?.data;
};

export const getDetectionRangeBySupplierName = async (
  supplierName: string,
  signal?: any,
) => {
  const res = await axios.get(
    `/slpapp/DetectionRange/GetDetectionRangeBySupplierName`,
    {
      params: { supplierName },
      signal,
    },
  );

  return res?.data;
};
